import { ChevronDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { ReactNode } from "react";

type CollapseProps = {
    testId?: string;
    className?: string;
    title: string;
    children: ReactNode;
    defaultOpen?: boolean;
};

export function Collapse({
    testId,
    className,
    title,
    children,
    defaultOpen = false,
}: CollapseProps) {
    return (
        <details
            className={clsx(
                "bg-secondary group w-full self-start rounded-md p-5",
                className,
            )}
            data-testid={testId}
            open={defaultOpen}
        >
            <summary className="cursor-pointer list-none">
                <div className="flex items-center justify-between">
                    <p className="heading-l">{title}</p>
                    <ChevronDownIcon className="size-5 transition-transform duration-200 group-open:rotate-180" />
                </div>
            </summary>
            <div className="mt-6">{children}</div>
        </details>
    );
}
